<template>
  <div class="currency">
    <div class="header">
      <div class="title">通用解决方案</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="right">
        <div class="list">
          <div class="item" v-for="item in rightList" :key="item.id">
            <div class="box" :style="`background-image: url(${item.back});`">
              <div class="blur">
                <div class="title">
                  <div class="left">
                    <img :src="item.logo" alt="" />
                    <div>{{ item.title }}</div>
                  </div>
                  <div class="right">
                    <router-link :to="item.path">
                      <div class="more">
                        <div>查看详情</div>
                        <img :src="more" alt="" />
                      </div>
                    </router-link>
                  </div>
                </div>
                <div class="text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import currencyDetails1 from "../../../assets/programme/currencyDetails1.png";
import currencyDetails2 from "../../../assets/programme/currencyDetails2.png";
import currencyDetails3 from "../../../assets/programme/currencyDetails3.png";
import currencyDetails4 from "../../../assets/programme/currencyDetails4.png";

import mobilecurrencylogo1 from "../../../assets/programme/mobilecurrencylogo1.png";
import mobilecurrencylogo2 from "../../../assets/programme/mobilecurrencylogo2.png";
import mobilecurrencylogo3 from "../../../assets/programme/mobilecurrencylogo3.png";
import mobilecurrencylogo4 from "../../../assets/programme/mobilecurrencylogo4.png";


import more from "../../../assets/programme/more.png";

export default {
  setup() {
    return reactive({
      more: more,
      titleId: 1,
      rightList: [
        {
          id: 1,
          back: currencyDetails1,
          title: "无人门岗解决方案",
          text: "去人工化岗亭管理  停车场降本增效",
          path: "/mobile/programme/doorpost",
          logo: mobilecurrencylogo1
        },
        {
          id: 2,
          back: currencyDetails2,
          title: "智能安防解决方案",
          text: "行业智能视觉应用  AI大数据监控视频",
          path: "/mobile/programme/security",
          logo: mobilecurrencylogo2
        },
        {
          id: 3,
          back: currencyDetails3,
          title: "智能消防解决方案",
          text: "物联网采集消防信息  打造可视化物联网消防平台",
          // path: "/mobile/programme/firecontrol",
          path: '',
          logo: mobilecurrencylogo3
        },
        {
          id: 4,
          back: currencyDetails4,
          title: "财务管理解决方案",
          text: "物业数字化财务系统综合应用",
          // path: "/mobile/programme/financeadmin",
          path: '',
          logo: mobilecurrencylogo4
        },
      ],
    });
  },
  methods: {
    currencyEnter(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.currency {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  width: 92vw;
  margin: 0 auto;
  margin-top: 16px;
}

.body .right .list .item {
  margin-bottom: 12px;
}
.body .right .list .item .box {
  height: 130px;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  display: flex;
  align-items: flex-end;
}
.body .right .list .item .box .blur {
  width: 100%;
  height: 44px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  backdrop-filter: blur(30px);
  padding: 9px;
}
.body .right .list .item .box .blur .title {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body .right .list .item .box .blur .title .left {
  display: flex;
  align-items: center;
}
.body .right .list .item .box .blur .title .left img {
width: 20px;
margin-right: 8px;
}
.body .right .list .item .box .blur .title .left div {
font-size: 14px;
}
.body .right .list .item .box .blur .text {
  font-size: 12px;
  margin-top: 8px;
}
.body .right .list .item .box .blur .more {
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  color: #fff;
}
.body .right .list .item .box .blur .more img {
  width: 14px;
  margin-left: 8px;
}
</style>
